import React, { useEffect, useState } from "react";
import Lottie from "react-lottie";
import {
  Button,
  Col,
  Container,
  FormGroup,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalHeader,
  Row,
} from "reactstrap";
import * as deleteTrash from "../../assets/lottieAnimation/delete.json";
import { ConvertDate } from "../Function/ConvertDate";
import axios from "axios";
import { GetCookieToken } from "../Cookie/GetCookie";

const ModalCancelLeave = ({
  leaveDataEdit,
  setLeaveDataEdit,
  cancelLeave,
  toggleCancelLeave,
  handleCancelLeave,
  allDayCancel,
  setAllDayCancel,
  getAllDayCancel,
  selectDayCancel,
  setSelectDayCancel,
}) => {
  const baseURL = process.env.REACT_APP_API_CORS;
  const token = GetCookieToken("userToken");

  const [isFullCancel, setIsFullCancel] = useState(true);
  const [cancelValidate, setCancelValidate] = useState(true);

  const [holiday, setHoliday] = useState([]);

  useEffect(() => {
    // if(leaveDataEdit?.form_type === 2) {
    //   setIsFullCancel(false)
    // }
    // if(leaveDataEdit?.cancel_reason?.trim() === "" || !leaveDataEdit?.hasOwnProperty("cancel_reason")){
    //   setCancelValidate(true)
    // } else {
    //   setCancelValidate(false)
    // }
  }, [leaveDataEdit]);
// แก้หน้านี้ก่อน
  const calculateCancelLeaveDay = (
    leavefromType,
    leaveToType,
    leaveDays,
    eTarget,
    DateItem
  ) => {
    if (leavefromType === "1" && leaveToType === "2") {
      if (eTarget === "0") {
        setSelectDayCancel((prev) =>
          prev.map((item) =>
            new Date(item?.date_cancel)?.toLocaleDateString() ===
            DateItem?.toLocaleDateString()
              ? {
                  ...item,
                  leave_from_timetype: "1",
                  leave_to_timetype: "2",
                }
              : item
          )
        );
        return leaveDays + 0;
      }
      if (eTarget === "1") {
        setSelectDayCancel((prev) =>
          prev.map((item) =>
            new Date(item?.date_cancel)?.toLocaleDateString() ===
            DateItem?.toLocaleDateString()
              ? {
                  ...item,
                  leave_from_timetype: "1",
                  leave_to_timetype: "1",
                }
              : item
          )
        );
        return leaveDays + 0.5;
      }
      if (eTarget === "2") {
        setSelectDayCancel((prev) =>
          prev.map((item) =>
            new Date(item?.date_cancel)?.toLocaleDateString() ===
            DateItem?.toLocaleDateString()
              ? {
                  ...item,
                  leave_from_timetype: "2",
                  leave_to_timetype: "2",
                }
              : item
          )
        );
        return leaveDays + 0.5;
      }
    } else if (leavefromType === "1" && leaveToType === "1") {
      if (eTarget === "0") {
        setSelectDayCancel((prev) =>
          prev.map((item) =>
            new Date(item?.date_cancel)?.toLocaleDateString() ===
            DateItem?.toLocaleDateString()
              ? {
                  ...item,
                  leave_from_timetype: "1",
                  leave_to_timetype: "2",
                }
              : item
          )
        );
        return leaveDays - 0.5;
      }
      if (eTarget === "1") {
        setSelectDayCancel((prev) =>
          prev.map((item) =>
            new Date(item?.date_cancel)?.toLocaleDateString() ===
            DateItem?.toLocaleDateString()
              ? {
                  ...item,
                  leave_from_timetype: "1",
                  leave_to_timetype: "1",
                }
              : item
          )
        );
        return leaveDays + 0;
      }
      if (eTarget === "2") {
        setSelectDayCancel((prev) =>
          prev.map((item) =>
            new Date(item?.date_cancel)?.toLocaleDateString() ===
            DateItem?.toLocaleDateString()
              ? {
                  ...item,
                  leave_from_timetype: "2",
                  leave_to_timetype: "2",
                }
              : item
          )
        );
        return leaveDays + 0;
      }
    } else if (leavefromType === "2" && leaveToType === "2") {
      if (eTarget === "0") {
        setSelectDayCancel((prev) =>
          prev.map((item) =>
            new Date(item?.date_cancel)?.toLocaleDateString() ===
            DateItem?.toLocaleDateString()
              ? {
                  ...item,
                  leave_from_timetype: "1",
                  leave_to_timetype: "2",
                }
              : item
          )
        );
        return leaveDays - 0.5;
      }
      if (eTarget === "1") {
        setSelectDayCancel((prev) =>
          prev.map((item) =>
            new Date(item?.date_cancel)?.toLocaleDateString() ===
            DateItem?.toLocaleDateString()
              ? {
                  ...item,
                  leave_from_timetype: "1",
                  leave_to_timetype: "1",
                }
              : item
          )
        );
        return leaveDays + 0;
      }
      if (eTarget === "2") {
        setSelectDayCancel((prev) =>
          prev.map((item) =>
            new Date(item?.date_cancel)?.toLocaleDateString() ===
            DateItem?.toLocaleDateString()
              ? {
                  ...item,
                  leave_from_timetype: "2",
                  leave_to_timetype: "2",
                }
              : item
          )
        );
        return leaveDays + 0;
      }
    }
  };

  const handleInputChange = (e, field) => {
    setLeaveDataEdit((prev) => ({
      ...prev,
      [field]: e.target.value,
    }));
  };

  const getHoliday = (year) => {
    axios
      .get(baseURL + `/api/masterdata/holiday/${year}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((res) => {
        setHoliday(res?.data?.result);
      })
      .catch((err) => {
        console.error(err);
      });
  };

  const calculateLeaveDays = (
    leavefromDate,
    leavefromTime,
    leavetoDate,
    leavetoTime
  ) => {
    let sum = 0;

    const isWeekend = (date) => {
      const day = new Date(date)?.getDay();
      return day === 6 || day === 0; // 6 คือวันเสาร์, 0 คือวันอาทิตย์
    };

    const isThaiPublic = (date) => {
      const localDate = new Date(date);
      localDate.setHours(0, 0, 0, 0);
      return holiday.some((item) => {
        const startDate = new Date(item?.date_start_holiday)?.setHours(
          0,
          0,
          0,
          0
        );
        const endDate = new Date(item?.date_end_holiday)?.setHours(0, 0, 0, 0);
        return localDate >= startDate && localDate <= endDate;
      });
    };

    if (leavefromTime === "1" && leavetoTime === "2") {
      for (
        let i = new Date(leavefromDate);
        i <= new Date(leavetoDate);
        i.setDate(i.getDate() + 1)
      ) {
        if (!isWeekend(i) && !isThaiPublic(i)) {
          sum++;
        }
      }
      sum = sum - 0;
      return sum;
    }
    if (leavefromTime === "1" && leavetoTime === "1") {
      for (
        let i = new Date(leavefromDate);
        i <= new Date(leavetoDate);
        i.setDate(i.getDate() + 1)
      ) {
        if (!isWeekend(i) && !isThaiPublic(i)) {
          sum++;
        }
      }
      sum = sum - 0.5;
      return sum;
    }
    if (leavefromTime === "2" && leavetoTime === "2") {
      for (
        let i = new Date(leavefromDate);
        i <= new Date(leavetoDate);
        i.setDate(i.getDate() + 1)
      ) {
        if (!isWeekend(i) && !isThaiPublic(i)) {
          sum++;
        }
      }
      sum = sum - 0.5;
      return sum;
    }
    if (leavefromTime === "2" && leavetoTime === "1") {
      for (
        let i = new Date(leavefromDate);
        i <= new Date(leavetoDate);
        i.setDate(i.getDate() + 1)
      ) {
        if (!isWeekend(i) && !isThaiPublic(i)) {
          sum++;
        }
      }
      sum = sum - 1;
      return sum;
    }
  };

  const RequestSaveCancelLeaveDay = async () => {
    try {
      selectDayCancel &&
        selectDayCancel?.map(async (item, idx) => {
          try {
            const res = await axios.post(
              baseURL + "/api/leave/cancel/list/save",
              {
                leave_data_id: item?.leave_data_id,
                date_cancel: ConvertDate(item?.date_cancel)?.toOnlyDate(),
                leave_from_timetype: item?.leave_from_timetype,
                leave_to_timetype: item?.leave_to_timetype,
                cancel_date_status: 2,
              },
              {
                headers: {
                  Authorization: `Bearer ${token}`,
                },
              }
            );
          } catch (err) {
            console.error(err);
          }
        });
    } catch (err) {
      console.error(err);
    }
  };

  const checkCancelTimeType = (cancelDayObject) => {
    return (cancelDayObject?.leave_from_timetype === "1" && cancelDayObject?.leave_to_timetype === "1") ? "1"
      : (cancelDayObject?.leave_from_timetype === "2" && cancelDayObject?.leave_to_timetype === "2") ? "2"
        : "0";
  }

  const [disButton, setDisButton] = useState(false)

  const handleSubmit = async () => {
    setDisButton(true)
    if (!cancelValidate) {
      await handleCancelLeave(
        leaveDataEdit?.leave_data_id,
        cancelLeave?.status
      );
      if(selectDayCancel?.length > 0) {
        await RequestSaveCancelLeaveDay()
      }
    }
    setDisButton(false)
  }

  return (
    <Modal
      size="lg"
      centered
      isOpen={cancelLeave?.modal}
      toggle={() => {
        toggleCancelLeave();
        setIsFullCancel(true);
        setCancelValidate(true)
      }}
    >
      <ModalHeader
        toggle={() => {
          toggleCancelLeave();
          setIsFullCancel(true);
          setCancelValidate(true)
        }}
      >
        {cancelLeave?.status === "8" ? "ยกเลิกใบลา" : "ขอยกเลิกใบลา"}
      </ModalHeader>
      <ModalBody>
        <Container>
          <Row>
            <Col xs={12}>
              <Row>
                <Col xs={12} className="d-flex justify-content-center">
                  <h3>
                    {cancelLeave?.status === "8"
                      ? "คุณต้องการยกเลิกใบลานี้ใช่หรือไม่"
                      : "คุณต้องการขอยกเลิกใบลานี้ใช่หรือไม่"}
                  </h3>
                </Col>
              </Row>

              <Row className="mt-4 d-flex align-items-center justify-content-center">
                <Col xxl={8} className="">
                  {leaveDataEdit?.form_type === 2 && (leaveDataEdit?.leave_status === "0" || leaveDataEdit?.leave_status === "5") && (leaveDataEdit?.leave_status !== "C") ? (
                    <FormGroup row className="d-flex align-items-center">
                      <Col xxl={1}>
                        <Input
                          name="cancelType"
                          type="radio"
                          defaultChecked={true}
                          className="border border-2 border-secondary font-size-18"
                          style={{ marginTop: "auto" }}
                          onChange={(e) => {
                            setIsFullCancel(true);
                            setLeaveDataEdit((prev) => ({
                              ...prev,
                              cancel_status: 1,
                            }));
                          }}
                        />
                      </Col>
                      <Label className="font-size-14 text-start" xxl={5}>
                        ยกเลิกทั้งฉบับ
                      </Label>
                      <Col xxl={1}>
                        <Input
                          name="cancelType"
                          type="radio"
                          className="border border-2 border-secondary font-size-18"
                          style={{ marginTop: "auto" }}
                          onChange={(e) => {
                            setIsFullCancel(false);
                            setLeaveDataEdit((prev) => ({
                              ...prev,
                              cancel_status: 2,
                            }));
                          }}
                        />
                      </Col>
                      <Label className="font-size-14 text-start" xxl={5}>
                        ยกเลิกบางวัน
                      </Label>
                    </FormGroup>
                  ) : ""}

                  <FormGroup row>
                    <Label xxl={3} className="text-end">
                      เหตุผล :{" "}
                    </Label>
                    <Col xxl={8}>
                      <Input
                        type="text"
                        placeholder="กรุณาระบุเหตุผล"
                        onChange={(e) => {
                          setLeaveDataEdit((prev) => ({
                            ...prev,
                            cancel_reason: e.target.value,
                          }));
                          if (e.target.value.trim() !== "") {
                            setCancelValidate(false);
                          } else {
                            setCancelValidate(true);
                          }
                        }}
                        invalid={cancelValidate}
                      />
                    </Col>
                  </FormGroup>
                </Col>
                {!isFullCancel && (
                  <Col xxl={8} className="">
                    <FormGroup row>
                      <Label className="text-end" xxl={3}>
                        ตั้งแต่วันที่ :
                      </Label>
                      <Label className="text-start" xxl={8}>
                        {ConvertDate(
                          leaveDataEdit?.leave_from_date
                        )?.toThaiDateDMY()}{" "}
                      </Label>
                    </FormGroup>
                    <FormGroup row>
                      <Label className="text-end" xxl={3}>
                        ถึงวันที่ :
                      </Label>
                      <Label className="text-start" xxl={8}>
                        {ConvertDate(
                          leaveDataEdit?.leave_to_date
                        )?.toThaiDateDMY()}
                      </Label>
                    </FormGroup>
                    <FormGroup row>
                      <Label className="text-end" xxl={3}>
                        ยกเว้นวันที่ :
                      </Label>
                      <Col xxl={8}>
                        <Input
                          type="select"
                          value=""
                          onChange={(e) => {
                            const selectedDate = new Date(e.target.value);
                            if (
                              e.target.value !== "" &&
                              selectDayCancel?.length === 0
                            ) {
                              let newValue = {
                                leave_data_id: leaveDataEdit?.leave_data_id,
                                date_cancel: selectedDate,
                                leave_from_timetype: "1",
                                leave_to_timetype: "2",
                              };

                              setLeaveDataEdit((prev) => ({
                                ...prev,
                                change_days: prev.change_days - 1,
                              }));
                              setSelectDayCancel((prev) => [...prev, newValue]);
                              setAllDayCancel((prev) =>
                                prev.filter(
                                  (item) =>
                                    new Date(
                                      item?.date_cancel
                                    )?.toLocaleDateString() !==
                                    selectedDate?.toLocaleDateString()
                                )
                              );
                            } else if (
                              !selectDayCancel?.find(
                                (i) =>
                                  new Date(
                                    i?.date_cancel
                                  )?.toLocaleDateString() ===
                                  selectedDate.toLocaleDateString()
                              )
                            ) {
                              let check = selectDayCancel?.find(
                                (i) =>
                                  new Date(
                                    i?.date_cancel
                                  )?.toLocaleDateString() ===
                                  selectedDate.toLocaleDateString()
                              );

                              let newValue = {
                                leave_data_id: parseInt(leaveDataEdit?.leave_data_id),
                                date_cancel: selectedDate,
                                leave_from_timetype: "1",
                                leave_to_timetype: "2",
                              };

                              setLeaveDataEdit((prev) => ({
                                ...prev,
                                change_days: prev.change_days - 1,
                              }));
                              setSelectDayCancel((prev) => [...prev, newValue]);
                              setAllDayCancel((prev) =>
                                prev.filter(
                                  (item) =>
                                    new Date(
                                      item?.date_cancel
                                    )?.toLocaleDateString() !==
                                    selectedDate?.toLocaleDateString()
                                )
                              );
                            }
                          }}
                        >
                          <option value="">เลือกวันที่ต้องการยกเลิก</option>
                          {allDayCancel &&
                            allDayCancel?.map((item, idx) => {
                              // let checkItem = CheckCancelDayIsweekEndOrThaiPublic(item?.date)
                              let checkAllWithSelectDay = selectDayCancel?.find(
                                (a) =>
                                  new Date(
                                    a?.date_cancel
                                  )?.toLocaleDateString() ===
                                  new Date(
                                    item?.date_cancel
                                  )?.toLocaleDateString()
                              );
                              let showDate = ConvertDate(
                                new Date(item?.date_cancel)
                              )?.toThaiDateDMY();
                              if (!checkAllWithSelectDay) {
                                return (
                                  <option
                                    key={idx}
                                    value={new Date(item?.date_cancel)}
                                  >
                                    {showDate}
                                  </option>
                                );
                              } else {
                                return null;
                              }
                            })}
                        </Input>
                      </Col>
                    </FormGroup>
                    {selectDayCancel?.length === 0 ? null : (
                      <FormGroup row className="d-flex align-items-center">
                        {selectDayCancel?.map((item, idx) => {
                          const DateItem = new Date(item?.date_cancel);
                          let showDate = ConvertDate(
                            item?.date_cancel
                          )?.toThaiDateDMY();

                          // let leaveDaysSum = leaveDataEdit?.leave_days;
                          return (
                            <React.Fragment key={idx}>
                              <Label className="text-end" xxl={6}>
                                <i
                                  style={{ cursor: "pointer" }}
                                  onClick={() => {
                                    const selectedDate = new Date(
                                      item?.date_cancel
                                    );
                                    let newValue = {
                                      date_cancel: selectedDate,
                                    };
                                    if (
                                      item?.leave_from_timetype === "1" &&
                                      item?.leave_to_timetype === "1"
                                    ) {
                                      setLeaveDataEdit((prev) => ({
                                        ...prev,
                                        change_days: prev?.change_days + 0.5,
                                      }));
                                    }
                                    if (
                                      item?.leave_from_timetype === "2" &&
                                      item?.leave_to_timetype === "2"
                                    ) {
                                      setLeaveDataEdit((prev) => ({
                                        ...prev,
                                        change_days: prev?.change_days + 0.5,
                                      }));
                                    }
                                    if (
                                      item?.leave_from_timetype === "1" &&
                                      item?.leave_to_timetype === "2"
                                    ) {
                                      setLeaveDataEdit((prev) => ({
                                        ...prev,
                                        change_days: prev?.change_days + 1,
                                      }));
                                    }
                                    setSelectDayCancel((prev) =>
                                      prev.filter(
                                        (item) =>
                                          new Date(
                                            item?.date_cancel
                                          )?.toLocaleDateString() !==
                                          selectedDate.toLocaleDateString()
                                      )
                                    );
                                    setAllDayCancel((prev) => [
                                      ...prev,
                                      newValue,
                                    ]);
                                  }}
                                  className="fa-solid fa-circle-xmark font-size-18 me-2 text-danger"
                                ></i>
                                {showDate}
                              </Label>
                              <Label style={{ textAlign: "end" }} xl={2} lg={3}>
                                ช่วงเวลา
                              </Label>
                              <Col xl={3} lg={9} md={9} className="mt-2">
                                <Input
                                  type="select"
                                  value={checkCancelTimeType(item)}
                                  onChange={(e) => {
                                    const selectedTime = e.target.value;
                                    const sumDay = calculateCancelLeaveDay(
                                      item?.leave_from_timetype,
                                      item?.leave_to_timetype,
                                      leaveDataEdit?.change_days,
                                      e.target.value,
                                      DateItem
                                    );
                                    setLeaveDataEdit((prev) => ({
                                      ...prev,
                                      change_days: sumDay,
                                    }));
                                  }}
                                >
                                  <option value="0">เต็มวัน</option>
                                  <option value="1">ครึ่งวันเช้า</option>
                                  <option value="2">ครึ่งวันบ่าย</option>
                                </Input>
                              </Col>
                            </React.Fragment>
                          );
                        })}
                      </FormGroup>
                    )}
                    <FormGroup
                      row
                      style={{ display: "flex", alignItems: "center" }}
                    >
                      <Label className="text-end" xxl={3} lg={3} md={3}>
                        รวม
                      </Label>
                      <Col xl={4} lg={9} md={9}>
                        <Input
                          disabled
                          type="text"
                          value={leaveDataEdit?.change_days}
                          readOnly
                          onChange={(e) => {
                            handleInputChange(e, "change_days");
                            const leaveDays = calculateLeaveDays(
                              leaveDataEdit?.leave_from_date,
                              leaveDataEdit?.leave_from_timetype,
                              leaveDataEdit?.leave_to_date,
                              leaveDataEdit?.leave_to_timetype
                            );
                          }}
                        />
                      </Col>
                    </FormGroup>
                  </Col>
                )}
              </Row>
            </Col>
          </Row>
          <Row
            className="mt-4"
            style={{ display: "flex", justifyContent: "end" }}
          >
            <Col xxl={3}>
              <Button
                disabled={disButton}
                onClick={() => {
                  handleSubmit()
                }}
                className="w-100"
                color="success"
              >
                {disButton === true ? (
                  <i className="bx bx-loader bx-spin font-size-16 align-middle me-2"></i>
                ) : (
                  "ตกลง"
                )}
              </Button>
            </Col>
            <Col xxl={3}>
              <Button
                className="w-100"
                color="secondary"
                onClick={toggleCancelLeave}
              >
                ย้อนกลับ
              </Button>
            </Col>
          </Row>
        </Container>
      </ModalBody>
    </Modal>
  );
};

export default ModalCancelLeave;
